import { render, staticRenderFns } from "./base-img.vue?vue&type=template&id=319b3259"
import script from "./base-img.vue?vue&type=script&lang=js"
export * from "./base-img.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports